module.exports = __webpack_public_path__ + "static/media/权益六@2x.7e3c1bf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_121/img/权益六@2x.png
// module id = 1141
// module chunks = 0